export const GET_ALERTS_BEGIN = 'GET_ALERTS_BEGIN'
export const GET_ALERTS_SUCCESS = 'GET_ALERTS_SUCCESS'
export const GET_ALERTS_ERROR = 'GET_ALERTS_ERROR'

export const DELETE_ALERT_BEGIN = 'DELETE_ALERT_BEGIN'
export const DELETE_ALERT_SUCCESS = 'DELETE_ALERT_SUCCESS'
export const DELETE_ALERT_ERROR = 'DELETE_ALERT_ERROR'

export const CREATE_ALERT_BEGIN = 'CREATE_ALERT_BEGIN'
export const CREATE_ALERT_SUCCESS = 'CREATE_ALERT_SUCCESS'
export const CREATE_ALERT_ERROR = 'CREATE_ALERT_ERROR'

export const UPDATE_ALERT_BEGIN = 'UPDATE_ALERT_BEGIN'
export const UPDATE_ALERT_SUCCESS = 'UPDATE_ALERT_SUCCESS'
export const UPDATE_ALERT_ERROR = 'UPDATE_ALERT_ERROR'


export const ADD_ALERT_DEPARTMENT_BEGIN = 'ADD_ALERT_DEPARTMENT_BEGIN'
export const ADD_ALERT_DEPARTMENT_SUCCESS = 'ADD_ALERT_DEPARTMENT_SUCCESS'
export const ADD_ALERT_DEPARTMENT_ERROR = 'ADD_ALERT_DEPARTMENT_ERROR'

export const DELETE_ALERT_DEPARTMENT_BEGIN = 'DELETE_ALERT_DEPARTMENT_BEGIN'
export const DELETE_ALERT_DEPARTMENT_SUCCESS = 'DELETE_ALERT_DEPARTMENT_SUCCESS'
export const DELETE_ALERT_DEPARTMENT_ERROR = 'DELETE_ALERT_DEPARTMENT_ERROR'



export const CLEAR_NEW_ALERT_STATE = 'CLEAR_NEW_ALERT_STATE'


